import { Component, h, Host, Prop } from '@stencil/core';
import Swiper, { Navigation, Pagination } from 'swiper';

@Component({
  tag: 'lilu-swiper',
  styleUrl: 'lilu-swiper.scss',
  shadow: false,
})
export class LiluSwiper {
  @Prop() type = '';
  @Prop() headerColor = '';
  @Prop() buttonType = '';

  defaultOptions: any = {
    modules: [Navigation, Pagination],
    loop: false,
    speed: 400,
    preloadImages: true,
    slidesPerView: 4,
    slidesPerGroup: 3,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    noSwipingClass: 'swiper-no-swiping',
    // Responsive breakpoints
    threshold: 5,
  };

  componentDidLoad() {
    if (this.type === 'fix') {
      new Swiper('.swiper-fix', {
        ...this.defaultOptions,
        pagination: {
          el: '.swiper-fix-pagination',
          type: 'fraction',
        },
        breakpoints: {
          // when window width is >= 0px
          0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 3,
            slidesPerGroup: 2,
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: 4,
          },
        },
      });
    } else if (this.type === 'five') {
      new Swiper('.swiper-five', {
        ...this.defaultOptions,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 0px
          0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        },
      });
    } else {
      new Swiper('.swiper', {
        ...this.defaultOptions,
        slidesPerView: 40,
        slidesPerGroup: 40,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 0px
          0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });
    }
  }

  render() {
    return (
      <Host>
        <div class={this.type === 'fix' ? 'swiper-fix swiper-product' : this.type === 'five' ? 'swiper-five swiper-product' : 'swiper swiper-product'}>
          <div class="swiper-link">
            <slot name="link"></slot>
          </div>
          {this.type === 'fix' ? (
            <div>
              <slot name="hidden-slider-backdrop"></slot>
              <slot name="fixed-overlay"></slot>
            </div>
          ) : null}
          <lilu-hr></lilu-hr>
          <div class="swiper-wrapper">
            <slot></slot>
          </div>
          <div class="swiper-navigation">
            <div class="swiper-fix-pagination swiper-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </Host>
    );
  }
}
